var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimilar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 60,
    viewBox: "0 0 60 60",
    width: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#314e55",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      fillRule: "evenodd"
    },
    transform: "translate(9 7)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.15384615 6h37.69230765l2.1538462 43h-42zm27.84615385 7c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2zm-18 0c1.1045695 0 2-.8954305 2-2s-.8954305-2-2-2-2 .8954305-2 2 .8954305 2 2 2z",
    fill: "#f28544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 25h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14 29h14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14 33h14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m32 11c0-6.07513225-4.9248678-11-11-11s-11 4.92486775-11 11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilar);
export default __webpack_public_path__ + "static/media/similar.f25f28473bb8d6c93755f07893ae7aab.svg";
export { ForwardRef as ReactComponent };